import React from 'react'
import Rte from '../../components/Rte/Rte'
import type { CtaViewModel } from '../../view-models/CtaViewModel'
import styles from './richtext-styles.css'
import cx from 'classnames'
import DividerComp from '../../components/DividerComp/DividerComp'
type Props = {
  source?: string
  cta?: CtaViewModel
  dividerHeadline?: string
  hideDivider?: boolean
  id?: string
  /*will be sent by backend for the Anchor Points*/
}

const Richtext = ({ source, cta, dividerHeadline, id, hideDivider }: Props) => {
  if (!source && !dividerHeadline) return null
  return (
    <div id={id || ''}>
      <Rte
        className={cx(styles.richtext)}
        source={source}
        dividerHeadline={dividerHeadline}
        cta={cta}
      />
      {!hideDivider && <DividerComp />}
    </div>
  )
}

Richtext.displayName = 'Richtext'
export default Richtext